export enum eConsumerTypes {
  seller = 'seller',
  borrower = 'borrower',
}
